module.exports = __webpack_public_path__ + "e40999cd519b3675401f5ab6501720c0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-media-and-formats.png
// module id = 2971
// module chunks = 0